<template>
  <div class="container">
    <CommonHeader
      title="设备运营服务费返还"
      :value="value"
    />
    <LongList
      :api-method="getData"
    >
      <template #default="{list}">
        <BillTable
          :data="list"
          :columns="columns"
        />
      </template>
    </LongList>
  </div>
</template>

<script>
import { formatAmount } from '@/util/filter';
import Api from '@/api/bill';
import BillTable from '@/components/BillTable';

export default {
  name: 'ServiceFeeRefundDetail',
  components: { BillTable },
  data() {
    const { amount, cutMonth } = this.$route.query;

    const columns = [
      {
        label: '机柜SN',
        prop: 'cabinSn',
      },
      {
        label: '服务费返还（元）',
        formatter: (row) => `${formatAmount(row.amount)}元`,
      },
    ];

    return {
      value: `账单金额：${formatAmount(amount)}元`,
      columns,
      cutMonth,
    };
  },
  methods: {
    getData(pageNum, pageSize) {
      const params = {
        billMonth: this.cutMonth,
        pageSize,
        pageNum,
      };
      return Api.queryServiceFeeRefundDetail(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 16px;
}
</style>
